(function () {
  function avvia(sez) {
    if (sez.dataset.rfPronta) return;
    sez.dataset.rfPronta = '1';
    var grandi = sez.querySelectorAll('[data-rf-i]');
    var voci = sez.querySelectorAll('[data-rf-v]');
    var pop = sez.querySelector('[data-rf-pop]');

    voci.forEach(function (v) {
      v.addEventListener('click', function () {
        var i = v.getAttribute('data-rf-v');
        voci.forEach(function (x) { x.classList.toggle('on', x === v); });
        grandi.forEach(function (g) { g.hidden = g.getAttribute('data-rf-i') !== i; });
      });
    });

    if (!pop) return;
    function apri() { pop.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function chiudi() { pop.hidden = true; document.documentElement.style.overflow = ''; }
    sez.querySelectorAll('[data-rf-apri]').forEach(function (b) { b.addEventListener('click', apri); });
    pop.querySelectorAll('[data-rf-chiudi]').forEach(function (b) { b.addEventListener('click', chiudi); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) chiudi(); });
  }

  function tutte() { document.querySelectorAll('.rf-recensioni').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
